var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.org && _vm.org.privacy_policy)?_c('div',[_c('div',{staticClass:"body"},[_c('p',{staticClass:"infotxt",staticStyle:{"white-space":"pre-wrap","word-wrap":"break-word"},domProps:{"innerHTML":_vm._s(_vm.linkedText)}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }